export const MAIL_LIST_GENERIC_ACTIVITY_LIST_SORT = 'MAIL_LIST_GENERIC_ACTIVITY_LIST_SORT';

export const MAIL_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE = 'MAIL_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE';
